import type { SVGProps } from "react";

/**
 * Stand-in identity until a designed logo exists: the braille cell for "S"
 * (dots 2, 3, 4 on the standard 1 4 / 2 5 / 3 6 cell), drawn on the same
 * 400-square grid as Gairm's braille "G" mark so the two read as siblings,
 * and in Gairm's orange (`text-brand`) for the same reason. `currentColor`
 * so the caller decides.
 */
export function StarsachMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 400 400" aria-hidden="true" focusable="false" fill="currentColor" {...props}>
      <circle cx="110" cy="200" r="50" />
      <circle cx="110" cy="320" r="50" />
      <circle cx="290" cy="80" r="50" />
    </svg>
  );
}

/** Gairm's braille "G" (dots 1, 2, 4, 5), as in gairm-npo-bpo/marketing/logo. */
export function GairmMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 400 400" aria-hidden="true" focusable="false" fill="currentColor" {...props}>
      <circle cx="110" cy="110" r="59" />
      <circle cx="110" cy="290" r="59" />
      <circle cx="290" cy="110" r="59" />
      <circle cx="290" cy="290" r="59" />
    </svg>
  );
}

/** Mark + wordmark, in the UI's own face; `as` picks the element (an h1 on the login screen). */
export function StarsachWordmark({ as: Tag = "span", className = "" }: { as?: "span" | "h1"; className?: string }) {
  return (
    <Tag className={`inline-flex items-center gap-2 font-semibold ${className}`}>
      <StarsachMark className="h-5 w-5 text-brand" />
      <span>Starsach</span>
    </Tag>
  );
}

/** Small and quiet, on every page: who makes this. */
export function PoweredBy({ className = "" }: { className?: string }) {
  return (
    <p className={`text-xs text-neutral-500 dark:text-neutral-400 ${className}`}>
      Powered by{" "}
      <a href="https://gairm.org" className="whitespace-nowrap font-medium hover:text-neutral-700 dark:hover:text-neutral-200" target="_blank" rel="noreferrer">
        <GairmMark className="mr-1 inline-block h-3 w-3 align-[-0.125em] text-brand" />
        Gairm
      </a>
      , an Idaho non-profit.
    </p>
  );
}
